import oizomDark from "../../assets/oizom-dark.png";
import oizomLight from "../../assets/oizom-light.png";

/**
 * Krypton product mark — the green leaf tile. Rendered as inline SVG (crisp at
 * any size, theme-independent). The supplied Krypton PNGs have a baked-in
 * transparency checkerboard, so we use this clean vector recreation instead;
 * swap in the real vector here when a clean SVG is provided.
 */
export function KryptonMark({
  size = 32,
  tone = "brand",
  className = "",
}: {
  size?: number;
  /** "brand" = green tile / white leaf (default). "inverted" = white tile /
   * green leaf, for use on the green brand surfaces. */
  tone?: "brand" | "inverted";
  className?: string;
}) {
  const tile = tone === "inverted" ? "#ffffff" : "#40AD48";
  const leaf = tone === "inverted" ? "#40AD48" : "#ffffff";
  const vein = tone === "inverted" ? "#ffffff" : "#40AD48";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      className={className}
      style={{ display: "block", flex: "none" }}
    >
      <rect x="2" y="2" width="96" height="96" rx="26" fill={tile} />
      <path d="M32 68 C 28 42, 48 26, 74 28 C 76 54, 56 72, 32 68 Z" fill={leaf} />
      <path d="M38 62 C 52 50, 64 40, 71 31" fill="none" stroke={vein} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

/** Krypton mark + wordmark, for dark surfaces (sidebar, login brand panel). */
export function KryptonBrand({ subtitle }: { subtitle?: string }) {
  return (
    <div className="flex items-center gap-2.5">
      <KryptonMark size={32} />
      <div className="leading-tight">
        <div className="text-[15px] font-bold tracking-tight text-white">Krypton</div>
        {subtitle ? (
          <div className="text-[9px] font-semibold uppercase tracking-[0.15em] text-sidemut">{subtitle}</div>
        ) : null}
      </div>
    </div>
  );
}

/** Oizom company endorsement ("Powered by [Oizom]"). Uses the real logo asset. */
export function OizomEndorsement({
  variant = "dark",
  className = "",
}: {
  variant?: "dark" | "light";
  className?: string;
}) {
  return (
    <div className={"flex items-center gap-2 " + className}>
      <span className="text-[10px] text-sidemut">Powered by</span>
      <img src={variant === "light" ? oizomLight : oizomDark} alt="Oizom" className="h-[18px] w-auto" />
    </div>
  );
}
